import { TranslationObject } from '../i18n/translation';

const namespace = 'vurdering/vurderingsliste';

const translations: TranslationObject = {
  student: {
    id: `${namespace}.student`,
    nb: 'Student',
    en: 'Student',
  },
  studiested: {
    id: `${namespace}.studiested`,
    nb: 'Studiested',
    en: 'Institution',
  },
  kontakt: {
    id: `${namespace}.kontakt`,
    nb: 'Kontaktinformasjon',
    en: 'Contact information',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  handling: {
    id: `${namespace}.handling`,
    nb: 'Handling',
    en: 'Actions',
  },
  statusAktiv: {
    id: `${namespace}.statusAktiv`,
    nb: 'Aktiv',
    en: 'Active',
  },
  statusAvbruttPraksis: {
    id: `${namespace}.statusAvbruttPraksis`,
    nb: 'Avbrutt praksis',
    en: 'Cancelled practice',
  },
  statusPraksisFullfoert: {
    id: `${namespace}.statusPraksisFullfoert`,
    nb: 'Praksis fullført',
    en: 'Practice completed',
  },
  btnHandlingMidt: {
    id: `${namespace}.btnHandlingMidt`,
    nb: 'Til midtveisvurdering',
    en: 'To mid-term evaluation',
  },
  btnHandlingSlutt: {
    id: `${namespace}.btnHandlingSlutt`,
    nb: 'Til sluttvurdering',
    en: 'To final evaluation',
  },
};

export default translations;
